module.exports = __webpack_public_path__ + "img/2.357760fc.png";